<template>
  <div>
    <div class="col-md-6 sem-letra" v-if="!getCurrent.song_data.lyric">
      <a href="#cx_letra_video"
         data-toggle="collapse"
         data-parent="#accordion"
         aria-expanded="true" aria-controls="cx_letra_video"
         id="fecharplayer" class="btn-fechar"><i class="fas fa-times"></i></a>
      Letra não disponível
    </div>
  </div>
</template>

<script>



  export default {
    name: "Semletra",
    mounted() {

      $(document).ready(function () {
        $("#fecharplayer").click(function () {
          $("#arrow").removeClass('btns_letra_video')
          $("#arrow").removeClass('collapsed')
          $("#arrow").addClass("btns_letra_video  collapsed")
        });

      });

      $('#scrollletra').mCustomScrollbar({
        axis: 'y',
        theme: 'light-3',
        advanced: {
          autoExpandHorizontalScroll: true,
          updateOnContentResize: true,
          updateOnImageLoad: true,
          autoUpdateTimeout: 10,
          updateOnSelectorChange: "ul li"
        },
        live: true
      });
    },
    computed: {
      getCurrent() {
        return this.$store.getters['getCurrentInfo']
      },
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/jqueryplugin/Semletra.vue